import { createExportTraceServiceRequest, } from '@opentelemetry/otlp-transformer';
import { MULTIPLAYER_TRACE_DEBUG_PREFIX, MULTIPLAYER_TRACE_DOC_PREFIX, MULTIPLAYER_TRACE_CONTINUOUS_DEBUG_PREFIX, } from './constants.base';
export var MultiplayerJsonTraceSerializer = {
    serializeRequest: function (arg) {
        var filteredArg = arg.filter(function (span) {
            var traceId = span.spanContext().traceId;
            if (traceId.startsWith(MULTIPLAYER_TRACE_DEBUG_PREFIX)
                || traceId.startsWith(MULTIPLAYER_TRACE_DOC_PREFIX)
                || traceId.startsWith(MULTIPLAYER_TRACE_CONTINUOUS_DEBUG_PREFIX)) {
                return true;
            }
            return false;
        });
        var request = createExportTraceServiceRequest(filteredArg, {
            useHex: true,
            useLongBits: false,
        });
        var encoder = new TextEncoder();
        return encoder.encode(JSON.stringify(request));
    },
    deserializeResponse: function (arg) {
        var decoder = new TextDecoder();
        return JSON.parse(decoder.decode(arg));
    },
};
//# sourceMappingURL=MultiplayerJsonTraceSerializer.js.map